import { IconButton } from '@mui/material';
import { useStyles } from './styles/HamburgerButton.styles';
import { Menu } from '@mui/icons-material';

interface HamburgerButtonProps {
    handleToggle: () => void;
}

export const HamburgerButton = ({ handleToggle }: HamburgerButtonProps) => {
    const classes = useStyles();

    return (
        <IconButton
            color='inherit'
            aria-label='Open drawer'
            edge='start'
            onClick={handleToggle}
            className={classes.menuButton}>
            <Menu />
        </IconButton>
    );
};
